export default function setCanonical(url) {
  console.log('setCanonical körs', url);
  if (!url) {
    url =
      window.location.origin +
      window.location.pathname +
      window.location.search;
  }
  let link = document.querySelector('link[rel="canonical"]');
  if (link) {
    link.setAttribute('href', url);
  } else {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  }
}
